import {
  ChangeDetectionStrategy,
  ChangeDetectorRef,
  Component,
  Input,
  OnDestroy,
  TrackByFunction,
  ViewEncapsulation
} from '@angular/core';
import { Store } from '@ngrx/store';
import { EmailConversation } from 'common/store/genesys-cloud/conversations/emails/models/email-conversation.model';
import { selectActiveEmailConversations } from 'common/store/genesys-cloud/conversations/emails/selectors/email-conversation.selectors';
import { merge, Subject } from 'rxjs';
import { debounceTime, map, takeUntil } from 'rxjs/operators';
import { WorkItemStateHandler } from 'shared/services/workitem-state-handler/workitem-state-handler.service';
import { taskItemAnimation } from '../shared/animations/task-item.animation';
import { MatDialog } from '@angular/material/dialog';
import { GenesysProactiveEmailModalComponent } from 'shared/components/genesys-proactive-email-modal/genesys-proactive-email-modal.component';
import { UserPermission as GenesysUserPermission } from 'common/store/genesys-cloud/users/models/user-permission.enum';

@Component({
  selector: 'app-work-item-genesys-email-list',
  templateUrl: './workitem-genesys-email-list.component.html',
  styleUrls: ['./workitem-genesys-email-list.component.scss'],
  animations: [taskItemAnimation],
  changeDetection: ChangeDetectionStrategy.OnPush,
  encapsulation: ViewEncapsulation.None
})
export class WorkItemGenesysEmailListComponent implements OnDestroy {
  @Input()
  isHybrid: boolean;
  readonly gcUserPermission = GenesysUserPermission;
  private readonly onDestroySubject = new Subject<void>();
  private readonly workItemChanges$ = merge(
    this.workItemStateHandler.workItemFocused$,
    this.workItemStateHandler.openedWorkItemsChanged$
  ).pipe(
    debounceTime(0),
    takeUntil(this.onDestroySubject)
  );

  constructor(private readonly store: Store,
    private readonly workItemStateHandler: WorkItemStateHandler,
    private readonly changeDetectorRef: ChangeDetectorRef,
    private readonly dialog: MatDialog) {
    this.workItemChanges$.subscribe(() => this.changeDetectorRef.detectChanges());
  }

  ngOnDestroy(): void {
    this.onDestroySubject.next();
    this.onDestroySubject.complete();
  }

  readonly emailConversations$ = this.store.select(selectActiveEmailConversations);
  readonly emailConversationCount$ = this.emailConversations$.pipe(map(conversations => conversations?.length || 0));

  readonly conversationTrackByFn: TrackByFunction<EmailConversation> = (_, conversation) => conversation?.id;

  toggleModal() {
    this.dialog.open(GenesysProactiveEmailModalComponent, {
      width: '500px'
    });
  }

  isOpened(conversationId: string): boolean {
    return this.workItemStateHandler.isOpened(conversationId);
  }

  isFocused(conversationId: string): boolean {
    return this.workItemStateHandler.isFocused(conversationId);
  }
}
